//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const GetGallery = async (params:string | null) => {
    const response = await axios.get(params != null ?`${baseURL}/images/gallery?${params}` : `${baseURL}/images/gallery`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
      },
    });
    return response.data;
}